import { useId } from "react";

interface LogoProps {
  size?: number;
  className?: string;
}

/**
 * ALETHEIA mark — "Minimal Monogram" concept (Concept 1): a bronze
 * two-stroke A monogram — a taller outer stroke with a base foot, and a
 * shorter inner stroke with a stepped notch, echoing the approved brand
 * reference. Strokes (not filled counters), round joins/caps, so it stays
 * crisp down to ~24px and survives a square or circular crop (Telegram
 * avatar, favicon, app icon).
 *
 * This is the single canonical location for the mark. Swapping in a further
 * refined vector later means replacing the <path> elements below without
 * touching any layout that renders <Logo />.
 */
export function Logo({ size = 40, className }: LogoProps) {
  const gradientId = useId();
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" role="img" aria-label="ALETHEIA" className={className}>
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="var(--color-accent-strong)" />
          <stop offset="55%" stopColor="var(--color-accent)" />
          <stop offset="100%" stopColor="var(--color-accent-deep)" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="14" fill="var(--color-bg-inset)" />
      <path
        d="M16 50 L34 12 L50 50 L38 50"
        fill="none"
        stroke={`url(#${gradientId})`}
        strokeWidth="6.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 50 L21 32 L25 32 L30 22 L44 50"
        fill="none"
        stroke={`url(#${gradientId})`}
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
